import { Card, CardContent, Typography } from '@mui/material';
import { IInvoicedPerMonthWidgetData } from '@legacy/apis/types/invoicedPerMonthAPI';
import { barChartPalette } from '@legacy/constants/colors';
import { useAxesTooltip } from '@mui/x-charts';

interface CustomTooltipProps {
  data: IInvoicedPerMonthWidgetData[];
  valueFormatter: (value: number | null) => string;
}

export const CustomTooltip = ({ data, valueFormatter }: CustomTooltipProps) => {
  const tooltipData = useAxesTooltip();
  const xAxisData = tooltipData?.find(
    ({ axisDirection }) => axisDirection === 'x',
  );

  if (!xAxisData || xAxisData.axisValue == null) {
    return null;
  }

  const { axisValue } = xAxisData;
  const dataPoint = data.find((item) => item.month === axisValue);
  return (
    <Card sx={{ minWidth: 200 }}>
      <CardContent>
        <Typography component="h3" gutterBottom>
          <strong>{String(axisValue)}</strong>
        </Typography>
        <Typography sx={{ color: barChartPalette[0] }} gutterBottom>
          {dataPoint?.lastYear}:{' '}
          {valueFormatter(dataPoint?.invoicedAmountLastYear ?? 0)}
        </Typography>
        <Typography sx={{ color: barChartPalette[1] }}>
          {dataPoint?.year}: {valueFormatter(dataPoint?.invoicedAmount ?? 0)}
        </Typography>
      </CardContent>
    </Card>
  );
};
